import { render, staticRenderFns } from "./StorageDialog.vue?vue&type=template&id=421cb28a&"
import script from "./StorageDialog.ts?vue&type=script&lang=ts&"
export * from "./StorageDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports